import { render } from "./OdsBackLink.vue?vue&type=template&id=0cfc0a60"
import script from "./OdsBackLink.vue?vue&type=script&lang=js"
export * from "./OdsBackLink.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__